export enum MarkerPriorityEnum {
    Normal = 0,
    Cluster = 1,
    Hovered = 2,
    Selected = 3,
    Popover = 10,
}
